const initialState = {
    itens: [
      {
        tipo: 'textocurto-cpf',
        pergunta: 'CPF',
        obrigatorio: true,
        id: 0
      },
      {
        tipo: 'textocurto',
        pergunta: 'Nome',
        obrigatorio: true,
        id: 1
      },
      {
        tipo: 'textocurto-dinheiro',
        pergunta: 'Valor',
        obrigatorio: true,
        id: 2
      },
      {
        tipo: 'data',
        pergunta: 'Data de Vencimento',
        obrigatorio: true,
        id: 3
      },
      {
        tipo: 'textocurto-cep',
        pergunta: 'CEP',
        obrigatorio: true,
        id: 4
      },
      {
        tipo: 'textocurto',
        pergunta: 'Logradouro',
        obrigatorio: true,
        id: 5
      },
      {
        tipo: 'textocurto',
        pergunta: 'Complemento',
        obrigatorio: false,
        id: 6
      },
      {
        tipo: 'numero',
        pergunta: 'Número',
        obrigatorio: false,
        id: 7
      },
      {
        tipo: 'textocurto',
        pergunta: 'Bairro',
        obrigatorio: true,
        id: 8
      }
    ],
    proximoIndexItens: 9,
    titulo: '',
    descricao: '',
    servicoBoleto: null,
    statusDisponibilidade: false
  };

export default function reduce(state = initialState, action = {}) {
    switch (action.type) {
        case 'ADD_ITEM_GRU':
            return addItem(state, action.payload);
        case 'DELETE_ITEM_GRU':
            return deleteItem(state, action.payload);
        case 'UPDATE_ITEM_GRU':
            return updateItem(state, action.payload);
        case 'UPDATE_TITULO_GRU':
            return updateTitulo(state, action.payload);
        case 'UPDATE_DESCRICAO_GRU':
            return updateDescricao(state, action.payload);
        case 'UPDATE_STATE_GRU':
            return updateState(state, action.payload);
        case 'RESET_STATE_GRU':
            return resetState(state);
        case 'UPDATE_STATUS_DISPONIBILIDADE_GRU':
            return updateStatusDisponibilidade(state, action.payload);
        case 'UP_CAMPO_GRU':
            return upCampo(state, action.payload)
        case 'DOWN_CAMPO_GRU':
            return downCampo(state, action.payload)
        case 'UPDATE_SERVICO_BOLETO_GRU':
            return updateServicoBoleto(state, action.payload)
        case 'UPDATE_IDENTIFICADOR_GRU':
            return updateIdentificadorGRU(state, action.payload)
        default:
            return state;
    }
}

function addItem(state, item){
    let id = state.proximoIndexItens;
    return {
        ...state,
        proximoIndexItens: id + 1,
        itens : [
            ...state.itens,
            {...item, id: id}
        ]
    }
}

function deleteItem(state, id){
    return {...state, itens: state.itens.filter(item =>
        item.id !== id
    )}
}

function updateItem(state, item){
    return {...state, itens: state.itens.map(itemN =>
            itemN.id === item.id ?
            item :
            itemN
    )}
}

function updateTitulo(state, titulo){
    return {...state, titulo: titulo}
}

function updateDescricao(state, descricao){
    return {...state, descricao: descricao}
}

function updateState(state, newState){
    return newState
}

function resetState(state){
    return initialState
}

function upCampo(state, item){
    const posicao = state.itens.indexOf(item)
    
    if(posicao > 0){
        const corrente_item = state.itens[posicao]
        const item_anterior =  state.itens[posicao - 1]

        state.itens[posicao] = item_anterior
        state.itens[posicao - 1] = corrente_item

    }

    return { ...state}
}

function downCampo(state, item){
    const posicao = state.itens.indexOf(item)

    if(posicao < state.itens.length - 1){
        const corrente_item = state.itens[posicao]
        const proximo_item =  state.itens[posicao + 1]

        state.itens[posicao] = proximo_item
        state.itens[posicao + 1] = corrente_item

    }

    return { ...state}
}

function updateStatusDisponibilidade(state, statusDisponibilidade){
    return {...state, statusDisponibilidade}
}

function updateServicoBoleto(state, servicoBoleto){
    return {...state, servicoBoleto: servicoBoleto}
}

function updateIdentificadorGRU(state, tipo){
    if(tipo === 'CPF'){
        return {...state, itens: state.itens.map(itemN =>
            itemN.id === 0 ?
            {tipo: 'textocurto-cpf',
            pergunta: 'CPF',
            obrigatorio: true,
            id: 0} :
            itemN
        )}
    }else if(tipo === 'CNPJ'){
        return {...state, itens: state.itens.map(itemN =>
            itemN.id === 0 ?
            {tipo: 'textocurto-cnpj',
            pergunta: 'CNPJ',
            obrigatorio: true,
            id: 0} :
            itemN
        )}
    }
}


// WEBPACK FOOTER //
// ./src/view/gru/actions/FormBuilderGRUReducer.js